import React from 'react';
import cn from 'classnames';
import { Icon } from 'ui';
import InfoTooltip from 'components/shared/InfoTooltip';
import DemonstrationGradersModal from './GradersModal/index';

class DemonstrationViewerContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      showFeedbackCriteriaDescriptionsById: {},
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.togglefeedbackCriteriaDescription =
      this.togglefeedbackCriteriaDescription.bind(this);
  }

  toggleModal() {
    this.setState(state => ({ isOpen: !state.isOpen }));
  }

  togglefeedbackCriteriaDescription(id) {
    this.setState(state => ({
      showFeedbackCriteriaDescriptionsById: {
        ...state.showFeedbackCriteriaDescriptionsById,
        [id]: !state.showFeedbackCriteriaDescriptionsById[id],
      },
    }));
  }

  render() {
    const { demonstration, graders, feedbackCriteria } = this.props;
    const { isOpen, showFeedbackCriteriaDescriptionsById } = this.state;
    const hasFeedbackCriteria = feedbackCriteria.length > 0;

    return (
      <div className="d-f px-32 pb-32 m-fd-c">
        <div className={cn('DemonstrationViewerPrompt', 'pt-32')}>
          <header className="pr-32">
            <h1 className="DemonstrationViewerPrompt-title text-wrap fz-bigger ff-ss fw-b mb-12">
              {t('demonstrations.prompt')}
            </h1>
            <p className="text-wrap">{demonstration.prompt}</p>
          </header>
        </div>
        <div className={cn('DemonstrationViewerGradingCriteria')}>
          <header>
            <div className="d-f fd-r jc-sb">
              <div className="d-f fd-r">
                <h1 className="DemonstrationViewerGradingCriteria-header text-wrap fz-bigger ff-ss fw-b">
                  {t('demonstrations.grading_criteria')}
                  <InfoTooltip
                    tooltip={t('demonstrations.grading_criteria_tooltip')}
                    className="ml-4"
                  />
                </h1>
              </div>
              {graders.length > 0 && (
                <div>
                  <button
                    className="u-linkBtn c-brand-blue lh-20"
                    type="button"
                    onClick={this.toggleModal}
                  >
                    {t('demonstrations.view_graders')}
                  </button>
                  {isOpen && (
                    <DemonstrationGradersModal
                      closeModal={this.toggleModal}
                      {...this.props}
                    />
                  )}
                </div>
              )}
            </div>
            {hasFeedbackCriteria ? (
              <div className="d-f fd-c lh-20 c-brand-gray-darkest">
                {feedbackCriteria.map(feedbackCriterion => (
                  <div
                    className="DemonstrationViewerGradingCriteria-items d-f fd-c"
                    key={feedbackCriterion.id}
                  >
                    <div
                      className={cn('d-f jc-sb ai-c', {
                        'mb-12':
                          showFeedbackCriteriaDescriptionsById[
                            feedbackCriterion.id
                          ],
                      })}
                    >
                      <span
                        className={cn({
                          'fw-b':
                            showFeedbackCriteriaDescriptionsById[
                              feedbackCriterion.id
                            ],
                        })}
                      >
                        {feedbackCriterion.name}
                      </span>
                      <div
                        className={cn({
                          't-sy--1':
                            showFeedbackCriteriaDescriptionsById[
                              feedbackCriterion.id
                            ],
                        })}
                      >
                        {feedbackCriterion.description && (
                          <button
                            className="u-resetBtn"
                            type="button"
                            onClick={() =>
                              this.togglefeedbackCriteriaDescription(
                                feedbackCriterion.id,
                              )
                            }
                          >
                            <Icon name="caret_down" />
                          </button>
                        )}
                      </div>
                    </div>
                    {feedbackCriterion.description &&
                      showFeedbackCriteriaDescriptionsById[
                        feedbackCriterion.id
                      ] && (
                        <div>
                          <span>{feedbackCriterion.description}</span>
                        </div>
                      )}
                  </div>
                ))}
              </div>
            ) : (
              <span className="c-gray-dark pt-12 d-f">
                {t('demonstrations.no_grading_criteria')}
              </span>
            )}
          </header>
        </div>
      </div>
    );
  }
}

export default DemonstrationViewerContent;
